var PropertyModelFactory,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define('models/contact/PropertyModel',["evertrue", "jquery", "underscore", "backbone", "ET/ETModel", "helpers/property-helper"], PropertyModelFactory = function(EverTrue, $, _, Backbone, ETModel, PropertyHelper) {
  var PropertyModel, formatName;
  formatName = function(name) {
    if (name == null) {
      name = "";
    }
    if (name.substr(-5) === "_list") {
      return name.slice(0, -5);
    } else if (name.substr(-6) === "_object") {
      return name.slice(0, -6);
    } else {
      return name;
    }
  };
  return PropertyModel = (function(_super) {
    __extends(PropertyModel, _super);

    function PropertyModel() {
      return PropertyModel.__super__.constructor.apply(this, arguments);
    }

    PropertyModel.prototype.urlRoot = "contacts/v1/properties";

    PropertyModel.prototype.defaults = {
      permissions: [],
      app_keys: [EverTrue.conf.app_keys.console],
      data_type: "string",
      "default": false
    };

    PropertyModel.prototype.create = function() {
      return this._saveObject();
    };

    PropertyModel.prototype.getLabel = function(name) {
      var containing_obj, prop, _ref;
      if (!_.isEmpty(this.get("description"))) {
        return this.get("description");
      } else if (this.get("containing_object")) {
        containing_obj = this.get("containing_object");
        if (((_ref = containing_obj.properties) != null ? _ref.length : void 0) > 0) {
          prop = _.findWhere(containing_obj.properties, {
            name: name
          });
          if (prop != null ? prop.description : void 0) {
            return prop.description;
          }
        }
      }
    };

    PropertyModel.prototype.getEnabledState = function(name) {
      var enabled_state, products;
      enabled_state = "hidden";
      products = EverTrue.DNA.get("ET.Org.Products");
      _.each(products, function(prod) {
        var has_item, json, profileJSON;
        profileJSON = PropertyHelper.getProfileJSON(prod.label);
        json = PropertyHelper.parsePropertyJSON(profileJSON);
        has_item = _.contains(json, name);
        if (has_item && enabled_state === "hidden") {
          if (products.length === 1) {
            return enabled_state = "visible";
          } else {
            return enabled_state = "partial";
          }
        } else if (has_item && enabled_state === "partial") {
          return enabled_state = "visible";
        }
      });
      return enabled_state;
    };

    PropertyModel.prototype.toPropObject = function() {
      var object, property;
      object = {
        data_type: "object",
        name: this.get("name") + "_object",
        "default": false
      };
      property = _.clone(this.attributes);
      object.properties = [property];
      return object;
    };

    PropertyModel.prototype._saveObject = function() {
      return EverTrue.api({
        url: this.urlRoot,
        type: "POST",
        data: this.toPropObject(),
        success: (function(_this) {
          return function(resp) {
            return _this._saveList(resp);
          };
        })(this)
      });
    };

    PropertyModel.prototype._saveList = function(object) {
      var list;
      list = new PropertyModel({
        name: formatName(this.get("name")) + "_list",
        data_type: "list",
        containing_object_name: object.name
      });
      return EverTrue.api({
        url: list.urlRoot,
        type: "POST",
        data: list.toJSON(),
        suppressGlobalErrorMsg: true,
        error: (function(_this) {
          return function(err) {
            var response;
            response = JSON.parse(err.responseText);
            if (response.message.match("Property: ta_list already exists for this object")) {
              EverTrue.alertView.alert("error", {
                message: "A custom field with this name has already been created"
              });
            } else {
              EverTrue.alertView.alert("error", {
                message: response.message
              });
            }
            return _this.trigger("saved:error");
          };
        })(this),
        success: (function(_this) {
          return function(resp) {
            var property;
            property = object.properties[0];
            property.parent_object = resp;
            property.parent_object.containing_object = _.omit(object, "properties");
            _this.set(property);
            return _this.trigger("saved");
          };
        })(this)
      });
    };

    PropertyModel.prototype["delete"] = function(callback) {
      var default_option, delete_functions, options1, options2, options3, opts;
      default_option = {
        type: "DELETE"
      };
      options1 = _.extend(_.clone(default_option), {
        url: this.urlRoot + "/" + this.get("id") + "/"
      });
      options2 = _.extend(_.clone(default_option), {
        url: this.urlRoot + "/" + this.get("parent_id") + "/"
      });
      options3 = _.extend(_.clone(default_option), {
        url: this.urlRoot + "/" + this.get("parent_object").id + "/"
      });
      opts = [options1, options2, options3];
      delete_functions = [];
      _.each(opts, function(opt) {
        return delete_functions.push(EverTrue.api(opt));
      });
      return $.when.apply(void 0, delete_functions).done(function() {
        EverTrue.alertView.alert("success", {
          message: "Custom field has been deleted."
        });
        if (_.isFunction(callback)) {
          return callback();
        }
      });
    };

    return PropertyModel;

  })(ETModel);
});

//# sourceMappingURL=PropertyModel.js.map
;
